<template>
  <product-content-dialog
    :model-value="modelValue"
    :title="$t('eprel.energyEfficiencyAndProductDatasheet')"
    @update:model-value="emit('update:modelValue', $event)"
  >
    <template #header>
      <v-tabs v-model="tab" bg-color="transparent" color="primary">
        <v-tab v-if="normalizedLabelUrl" :value="ENERGY_EFFICIENCY_TAB">
          {{ $t('eprel.energyEfficiency') }}
        </v-tab>

        <v-tab v-if="eprelInfo?.datasheetUrl" :value="PRODUCT_DATASHEET_TAB">
          {{ $t('eprel.energyEfficiencyInformationSheet') }}
        </v-tab>
      </v-tabs>

      <v-divider />
    </template>

    <v-window v-model="tab" class="fill-height">
      <v-window-item v-if="normalizedLabelUrl" :value="ENERGY_EFFICIENCY_TAB" class="fill-height">
        <div class="d-flex justify-center align-center fill-height w-100">
          <v-img
            :src="normalizedLabelUrl"
            :alt="$t('eprel.energyEfficiency')"
            class="h-100 w-100"
            contain
          />
        </div>
      </v-window-item>

      <v-window-item
        v-if="eprelInfo?.datasheetUrl"
        :value="PRODUCT_DATASHEET_TAB"
        class="fill-height"
      >
        <iframe
          :src="eprelInfo.datasheetUrl"
          :title="$t('eprel.energyEfficiencyInformationSheet')"
          width="100%"
          class="h-100 w-100 border-0"
        />
      </v-window-item>
    </v-window>
  </product-content-dialog>
</template>

<script setup lang="ts">
import ProductContentDialog from '@/modules/product/components/ProductContentDialog.vue'
import { type EprelInfo } from '@/types/index'
import { computed, ref, watch, type PropType } from 'vue'

const ENERGY_EFFICIENCY_TAB = 'energyEfficiency'
const PRODUCT_DATASHEET_TAB = 'productDatasheet'

const props = defineProps({
  modelValue: {
    type: Boolean,
    required: true
  },
  eprelInfo: {
    type: Object as PropType<EprelInfo | null>,
    default: null
  }
})

const emit = defineEmits<{
  'update:modelValue': [value: boolean]
}>()

const tab = ref<typeof ENERGY_EFFICIENCY_TAB | typeof PRODUCT_DATASHEET_TAB>(ENERGY_EFFICIENCY_TAB)
const normalizedLabelUrl = computed(() => {
  const labelUrl = props.eprelInfo?.labelUrl?.trim()
  if (!labelUrl) {
    return null
  }

  return labelUrl.replace(/^['"]|['"]$/g, '')
})

watch(
  () => props.modelValue,
  (isOpen) => {
    if (!isOpen) {
      return
    }

    tab.value = normalizedLabelUrl.value ? ENERGY_EFFICIENCY_TAB : PRODUCT_DATASHEET_TAB
  }
)
</script>
